import { Link } from 'react-router-dom';

import Button from '../../../common/components/button/button';
import RelativeTime from '../../../common/components/relative-time/relative-time';
import StatusPill from '../../../common/components/status-pill/status-pill';
import PauseIcon from '../../../common/icons/pause';
import PlayIcon from '../../../common/icons/play';
import {
    AGENT_ROLE_LABEL,
    AGENT_STATUS_LABEL,
    AGENT_STATUS_TONE,
    PROVIDER_LABEL,
    STALE_REASON_LABEL,
} from '../../../core/constants/domain';
import { ROUTES } from '../../../core/constants/routes';
import { useNotice } from '../../../global/contexts/notice/notice';
import { useSimulation } from '../contexts/simulation';
import { CONTROL, nextSimulatedControl } from '../utils/agents';

import '../styles/agent-row.css';

function SimulationAction({ agent }) {
    const { simulate, undo } = useSimulation();
    const { notify } = useNotice();

    if (agent.simulatedControl) {
        return (
            <Button size="small" variant="ghost" onClick={() => undo(agent.seat.id)}>
                Deshacer simulación
            </Button>
        );
    }

    const target = nextSimulatedControl(agent);
    const isPause = target === CONTROL.PAUSED;
    const handleClick = () => {
        simulate(agent.seat.id, target);
        notify({
            tone: 'info',
            message: `${isPause ? 'Pausa' : 'Habilitación'} simulada solo en esta pantalla. Core no recibió ninguna orden.`,
        });
    };

    return (
        <Button
            size="small"
            variant="secondary"
            icon={isPause ? <PauseIcon size={16} /> : <PlayIcon size={16} />}
            onClick={handleClick}
            aria-label={`${isPause ? 'Simular pausa de tomas' : 'Simular habilitación'} de ${agent.seat.label}`}
        >
            {isPause ? 'Simular pausa' : 'Simular habilitar'}
        </Button>
    );
}

export default function AgentRow({ agent, isDetailed = false }) {
    const { seat, status } = agent;
    return (
        <li className={`agent-row agent-row--${status}`}>
            <div className="agent-row__head">
                <span className="agent-row__name">{seat.label}</span>
                <StatusPill tone={AGENT_STATUS_TONE[status]}>
                    {AGENT_STATUS_LABEL[status]}
                    {agent.simulatedControl && <span className="agent-row__simulated"> · simulado</span>}
                </StatusPill>
            </div>
            <p className="agent-row__activity">
                {seat.task
                    ? <Link to={ROUTES.TASK(seat.task.id)} className="agent-row__task">{seat.task.title}</Link>
                    : <span className="agent-row__idle">Sin tarea en ejecución</span>}
            </p>
            <p className="agent-row__meta">
                <span>Última señal <RelativeTime value={seat.lastSeenAt} /></span>
                <span>{AGENT_ROLE_LABEL[seat.role] ?? seat.role}</span>
                <span>{PROVIDER_LABEL[seat.provider] ?? seat.provider}</span>
                {isDetailed && seat.machineLabel && <span className="mono">{seat.machineLabel}</span>}
            </p>
            {seat.staleReasons.length > 0 && (
                <p className="agent-row__reasons">
                    {seat.staleReasons.map((reason) => STALE_REASON_LABEL[reason] ?? reason).join(' · ')}
                </p>
            )}
            <div className="agent-row__actions">
                <SimulationAction agent={agent} />
            </div>
        </li>
    );
}
